import { Dispatch, SetStateAction, useRef, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { OctagonButton } from "@/common/buttons";
import { InlineDiv } from "@/common/divs";
import { InputWithNoBorder } from "@/common/inputs";
import {
  PRIMARY_BRAND_VARIANT_COLOR,
  PRIMARY_BUTTON_COLOR,
  PRIMARY_BUTTON_COLOR_DISSABLED,
  SECONDARY_BUTTON_COLOR,
} from "@/utils/constants";

interface SelectCountOptionsProps {
  min: number;
  max: number;
  typeOfCustomField: "SCHEDULE" | "TARIFF";
  scheduleCustomFields?: { pk: number; value: string | number | boolean }[];
  tariffCustomFields?: any;
  index: number;
  pk: number;
  secondaryIndex?: number;
  objectKey?: string;
  type?: string;
  isRequired?: boolean;
  title?: string;
  name?: string;
  setRequiredMissingScheduledFields?: Dispatch<SetStateAction<number>>;
}
const SelectCountOptions: React.FC<SelectCountOptionsProps> = ({
  min,
  max,
  typeOfCustomField,
  scheduleCustomFields,
  tariffCustomFields,
  index,
  pk,
  secondaryIndex,
  objectKey,
  type,
  isRequired,
  title,
  name,
  setRequiredMissingScheduledFields,
}) => {
  const [personas, setPersonas] = useState<string>("0");
  const updated = useRef(false);
  const handleChangePersonas = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (
      parseInt(event.target.value) > max ||
      parseInt(event.target.value) < min
    ) {
      return;
    }
    if (isRequired) {
      if (updated.current) {
        if (personas == "" && parseInt(event.target.value) > 0) {
          if (setRequiredMissingScheduledFields) {
            setRequiredMissingScheduledFields((prevState) => prevState - 1);
          }
        }
        if (parseInt(personas) > 0 && event.target.value == "") {
          if (setRequiredMissingScheduledFields) {
            setRequiredMissingScheduledFields((prevState) => prevState + 1);
          }
        }
      } else {
        if (parseInt(event.target.value) > 0) {
          if (setRequiredMissingScheduledFields) {
            setRequiredMissingScheduledFields((prevState) => prevState - 1);
            updated.current = true;
          }
        } else {
          if (setRequiredMissingScheduledFields) {
            setRequiredMissingScheduledFields((prevState) => prevState + 1);
            updated.current = true;
          }
        }
      }
    }
    setPersonas(event.target.value);
    handleUpdateCustomFields(event.target.value);
  };
  const handleUpdateCustomFields = (value: string) => {
    if (typeOfCustomField == "SCHEDULE" && scheduleCustomFields) {
      scheduleCustomFields[index] = {
        pk: pk,
        value: parseInt(value),
      };
    }
    if (typeOfCustomField == "TARIFF" && tariffCustomFields) {
      //@ts-ignore

      tariffCustomFields[objectKey][index][secondaryIndex] = {
        pk: pk,
        value: value,
        type: type ?? "count",
        isRequired: isRequired ?? false,
        title: title ?? "",
        name: name ?? "",
      };
    }
  };

  const handleIncrement = () => {
    if (personas == "") {
      setPersonas("1");
      handleUpdateCustomFields("1");
      if (!updated.current && isRequired) {
        if (setRequiredMissingScheduledFields) {
          setRequiredMissingScheduledFields((prevState) => prevState - 1);
          updated.current = true;
        }
      }
    } else {
      if (max > parseInt(personas)) {
        setPersonas((parseInt(personas) + 1).toString());
        handleUpdateCustomFields((parseInt(personas) + 1).toString());
        if (!updated.current && isRequired) {
          if (setRequiredMissingScheduledFields) {
            setRequiredMissingScheduledFields((prevState) => prevState - 1);
            updated.current = true;
          }
        }
      }
    }
  };

  const handleDecrement = () => {
    if (min < parseInt(personas)) {
      setPersonas((parseInt(personas) - 1).toString());
      (parseInt(personas) - 1).toString();
      if (!updated.current && isRequired) {
        if (setRequiredMissingScheduledFields) {
          setRequiredMissingScheduledFields((prevState) => prevState - 1);
          updated.current = true;
        }
      }
    }
  };
  const getBorderColor = (simbol: string) => {
    if (simbol === "+") {
      if (personas === max.toString()) {
        return PRIMARY_BUTTON_COLOR_DISSABLED;
      } else {
        return PRIMARY_BUTTON_COLOR;
      }
    } else {
      if (personas === min.toString() || personas === "") {
        return PRIMARY_BUTTON_COLOR_DISSABLED;
      } else {
        return PRIMARY_BUTTON_COLOR;
      }
    }
  };

  const getBackgroundColor = (simbol: string) => {
    if (simbol === "+") {
      if (personas === max.toString()) {
        return SECONDARY_BUTTON_COLOR;
      } else {
        return PRIMARY_BRAND_VARIANT_COLOR;
      }
    } else {
      if (personas === min.toString() || personas === "") {
        return SECONDARY_BUTTON_COLOR;
      } else {
        return PRIMARY_BRAND_VARIANT_COLOR;
      }
    }
  };
  return (
    <InlineDiv style={{ alignItems: "center", marginTop: "5px" }}>
      <OctagonButton
        style={{
          borderRadius: "50px",
          border: "1px solid " + getBorderColor("-"),
        }}
        width="24px"
        height="24px"
        backgroundColor={getBackgroundColor("-")}
        onClick={() => {
          handleDecrement();
        }}
      >
        <RemoveIcon fontSize="small" style={{ color: getBorderColor("-") }} />
      </OctagonButton>
      <InputWithNoBorder
        type="number"
        className="personas-input"
        placeholder="1"
        name="personas"
        value={personas}
        onChange={(e) => {
          handleChangePersonas(e);
        }}
      />
      <OctagonButton
        style={{
          borderRadius: "50px",
          border: "1px solid " + getBorderColor("+"),
        }}
        width="24px"
        height="24px"
        backgroundColor={getBackgroundColor("+")}
        onClick={() => {
          handleIncrement();
        }}
      >
        <AddIcon fontSize="small" style={{ color: getBorderColor("+") }} />
      </OctagonButton>
    </InlineDiv>
  );
};

export default SelectCountOptions;
